var React = require('react');

function Question (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_215","data-name":"Path 215","d":"M209.695,203.876a5.836,5.836,0,0,0-3.2-5.2,7.936,7.936,0,0,1-7.815,7.815,5.82,5.82,0,0,0,8.157,2.392l2.832.783-.783-2.832A5.8,5.8,0,0,0,209.695,203.876Zm0,0","transform":"translate(-191.695 -191.695)","key":0}),React.createElement("path",{"id":"Path_216","data-name":"Path 216","d":"M13.746,6.873A6.873,6.873,0,1,0,.953,10.367L.025,13.721l3.354-.928a6.874,6.874,0,0,0,10.367-5.92Zm-7.928-1.6H4.764A2.109,2.109,0,1,1,8.3,6.83l-.9.82v.822H6.346V7.186L7.584,6.052a1.044,1.044,0,0,0,.343-.779,1.055,1.055,0,0,0-2.109,0Zm.527,4.254H7.4v1.055H6.346Zm0,0","key":1})]);
}

Question.defaultProps = {"id":"question","width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Question;

Question.default = Question;
